<template>
    <v-container fluid>
        <v-row>
            <v-col md="9">
              <v-card color="primary" min-height="160">
                <v-card-title class="font-weight-bold">Alert Monitor</v-card-title>
                  <v-data-table dense :items-per-page="15" :headers="headers" :items="alertsData" :custom-sort="customSort">
                    <template v-slot:item.severity ="{ item }">
                      <v-chip :color="getSeverityColor(item.severity)">{{ item.severity }}</v-chip>
                    </template>
                    <template v-slot:item.timestamp ="{ item }">
                      {{ formatDate(item.timestamp) }}
                    </template>
                    <template v-slot:item.actions = "{ item }">
                      <v-btn icon @click="editRecord(item, getDialog(item.resolved))"><v-icon>{{ getIconResolved(item.resolved)}}</v-icon></v-btn>
                    </template>
                  </v-data-table>
              </v-card>
           </v-col>
            <v-col md="3">
              <v-container grid-list-lg>
                <v-layout row justify-center>

                  <v-flex>
                    <v-card color="primary">
                      <v-card-title class="font-weight-bold">Date Range</v-card-title>
                        <v-menu ref="menu1" v-model="menu1" min-width="290px" transition="scale-transition" :close-on-content-click="false">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field class="mx-4" prepend-icon="fa-calendar-alt" outlined v-model="dates[0]" label="Start date range" readonly v-bind="attrs" v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="dates[0]" header-color="secondary">
                          <v-spacer></v-spacer>
                          <v-btn text color="accent" @click="menu1 = false">Close</v-btn>
                        </v-date-picker>
                        </v-menu>

                        <v-menu ref="menu2" v-model="menu2" min-width="290px" transition="scale-transition" :close-on-content-click="false">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field class="mx-4" prepend-icon="fa-calendar-alt" outlined v-model="dates[1]" label="End date range" readonly v-bind="attrs" v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="dates[1]" header-color="secondary">
                          <v-spacer></v-spacer>
                          <v-btn text color="accent" @click="menu2 = false">Close</v-btn>
                        </v-date-picker>
                        </v-menu>                  
                    </v-card>
                  </v-flex>

                  <v-flex>
                    <v-card>
                      <v-toolbar color="primary" flat>
                        <v-toolbar-title class="font-weight-bold">Status</v-toolbar-title>
                      </v-toolbar>
                      <v-card-text>
                        <v-chip-group v-model="statusFilter" multiple column>
                          <div v-for="ele in alertsSchema.statusType" :key="ele">
                            <v-chip filter filter-icon="fa-plus-circle">{{ ele }}</v-chip>
                          </div>
                        </v-chip-group>
                      </v-card-text>
                    </v-card>
                  </v-flex>

                  <v-flex>
                    <v-card>
                      <v-toolbar color="primary" flat>
                        <v-toolbar-title class="font-weight-bold">Severity</v-toolbar-title>
                      </v-toolbar>
                      <v-card-text>
                        <v-chip-group v-model="severityFilter" multiple column>
                          <div v-for="ele in alertsSchema.severityType" :key="ele">
                            <v-chip filter :color="getSeverityColor(ele)" filter-icon="fa-plus-circle">{{ ele }}</v-chip>
                          </div>
                        </v-chip-group>
                      </v-card-text>
                    </v-card>
                  </v-flex>

                  <v-flex>
                    <v-card>
                      <v-toolbar color="primary" flat>
                        <v-toolbar-title class="font-weight-bold">Alert Type</v-toolbar-title>
                      </v-toolbar>
                      <v-card-text>
                        <v-chip-group v-model="alertTypeFilter" multiple column>
                          <div v-for="ele in alertsSchema.alertType" :key="ele">
                            <v-chip filter filter-icon="fa-plus-circle">{{ ele }}</v-chip>
                          </div>
                        </v-chip-group>
                      </v-card-text>
                    </v-card>
                  </v-flex>

                </v-layout>
              </v-container>
           </v-col>
        </v-row>

        <v-row justify="center">
          <v-dialog v-model="dialog[0].status" max-width="500">
          <v-card>
            <v-card-title class="headline">New Alert Record</v-card-title>
              <v-card-text>
                <v-text-field v-model="editedItem.engineer" label="Engineer Name"></v-text-field>
              </v-card-text>
              <v-card-text>
                <v-text-field v-model="editedItem.comment" label="Report"></v-text-field>
              </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="success" text @click="saveRecord">Save</v-btn>
              <v-btn color="warning" text @click="dialog[0].status = false">Cancel</v-btn>
            </v-card-actions>
          </v-card>
          </v-dialog>
        </v-row>

        <v-row justify="center">
          <v-dialog v-model="dialog[1].status" max-width="500">
          <v-card>
            <v-card-title class="headline">View Alert Record</v-card-title>
              <v-card-text><h3>Engineer:</h3>{{ editedItem.engineer }}</v-card-text>
              <v-card-text><h3>Report</h3>{{ editedItem.comment }}</v-card-text>
              <v-card-text><h3>Updated:</h3>{{ formatDate(editedItem.timeRectified) }}</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="warning" text @click="dialog[1].status = false">Close</v-btn>
            </v-card-actions>
          </v-card>
          </v-dialog>
        </v-row>

    </v-container>
</template>

<script>
import * as d3 from "d3-time-format";

  export default {
    props: {
      alertsData: Array,
      alertsSchema: Object,
    },
    data: () => ({
      menu1: false,
      menu2: false,
      dialog: [{status: false}, {status: false}],
      dates: ["2020-01-01","2020-12-31"],
      statusFilter: [0,1],
      severityFilter: [0,1,2],
      alertTypeFilter: [0,1,2,3],
      editedIndex: -1,
      editedItem: {
        engineer: "",
        comment: "",
        timeRectified: null
      }
    }),
    computed: {
      headers: function() {
      return [
        { text: 'Timestamp', value: 'timestamp',
          filter: value => {
            let timestamp = value.getTime();
            let date1 = Date.parse(this.dates[0]);
            let date2 = Date.parse(this.dates[1]);
            if (timestamp > Math.min(date1, date2) && timestamp <= Math.max(date1, date2))
              return true;
          }
        },
        { text: 'Severity', value: 'severity', 
          filter: value => {
            let filter = false;
            this.severityFilter.forEach(ele => {
              if (this.alertsSchema.severityType[ele] == value) {
                filter = filter || true;
              } else {
                filter = filter || false;
              }
            })
          return filter;
          }
        },
        { text: 'Alert Type', value: 'alertType',
          filter: value => {
            let filter = false;
            this.alertTypeFilter.forEach(ele => {
              if (this.alertsSchema.alertType[ele] == value) {
                filter = filter || true;
              } else {
                filter = filter || false;
              }
            })
          return filter;
          }                
        },
        { text: 'Node name', value: 'nodename' },
        { text: 'Source IP', value: 'sourceIp', sortable: false },
        { text: 'Destination IP', value: 'destIp', sortable: false },
        { text: 'Resolved', value: 'resolved',
          filter: value => {
            let filter = false;
            this.statusFilter.forEach(ele => {
              if (this.alertsSchema.statusType[ele] == value) {
                filter = filter || true;
              } else {
                filter = filter || false;
              }
            })
          return filter;
          }
        },
        { text: 'Actions', value: 'actions', sortable: false }
      ]}
    },
    methods: {
      editRecord(item, index){
        this.editedIndex = this.alertsData.indexOf(item);
        this.editedItem = Object.assign({}, item.report)
        this.dialog[index].status = true;
      },
      saveRecord(){
        if (this.editedIndex > -1) {
          this.editedItem.timeRectified = new Date();
          Object.assign(this.alertsData[this.editedIndex].report, this.editedItem)
          this.alertsData[this.editedIndex].resolved = "resolved";
        }
        this.dialog[0].status = false;
      },
      customSort(items, index, isDesc) {
        items.sort((a, b) => {
          if (index[0] == "timestamp") {
            if (!isDesc[0]) {
              return a.timestamp - b.timestamp;
            } else {
              return b.timestamp - a.timestamp;
            }
          } else {
            if (!isDesc[0]) {
              return a[index[0]] < b[index[0]] ? -1 : 1;
            } else {
              return b[index[0]] < a[index[0]] ? -1 : 1;
            }
          }
        });
        return items;
      },
      formatDate(date){
        let format = d3.timeFormat("%B %d, %Y %H:%M:%S");
        return format(date);
      },
      getSeverityColor(severity){
        if (severity == "low") {
          return "green";
        } else if (severity == "moderate") {
          return "yellow";
        } else {
          return "red";
        }
      },
      getIconResolved(resolved){
        if (resolved == "resolved") {
          return "fa-eye";
        } else {
          return "fa-pencil-alt";
        }
      },
      getDialog(resolved){
        if (resolved == "resolved") {
          return 1;
        } else {
          return 0;
        }
      }
    },
    mounted: function() {
    }
  }
  
</script>